import { useMemo } from "react";
import { useListMembers } from "./useListMembers";

// Which Lists are Shared. A List counts as Shared from the moment an
// Invitation is sent (CONTEXT.md), so this is every list_id with any row at
// all in list_members — not just accepted ones — matching the database's
// own user_active_task_count().
//
// Derived from useListMembers rather than fetched: RLS hands both the exact
// same rows, so a second round trip to list_members bought nothing but a
// second cache to keep in step — and the two did fall out of step (an
// invitation left the "shared" mark missing until the next page load).
// There is now one cache, one invalidation, and no way for them to disagree.
export function useSharedListIds() {
  const { data: members } = useListMembers();

  const data = useMemo(
    () => (members ? new Set(members.map((m) => m.list_id)) : undefined),
    [members],
  );

  return { data };
}
